import styled from "styled-components";
import Button from "@mui/material/Button";
import { Box, Typography } from "@mui/material";

export const FilterButton = styled(Button)`
  background-color: #f2f2f2;
  color: #64666a;
`;

export const DialogBoxWrap = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "2rem",
  columnGap: "2rem",
  overflow: "hidden",
  borderRadius: "1rem",
  "@media only screen and (min-width: 750px)": {
    width: "74.5rem",
    height: "31rem",
  },
  "@media only screen and (max-width: 750px)": {
    maxWidth: "74.5rem",
    width: "100%",
    flexDirection: "column",
    height: "auto",
  },
}));

export const AvtarCardBoxWrap = styled(Box)(() => ({
  flexBasis: "26%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  rowGap: "1rem",
  backgroundColor: "#F2F2F2",
  borderRadius: "0.5rem",
  height: "100%",
  padding: "2rem",
  "@media only screen and (max-width: 750px)": {
    flexDirection: "row",
  },
}));

export const AvtarCardBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "-webkit-fill-available",
  rowGap: "1rem",
}));

export const DetailBoxWrap = styled(Box)(() => ({
  flexBasis: "74%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#F2F2F2",
  height: "100%",
  borderRadius: "0.5rem",
  padding: "2.5rem 2.4rem 1.6rem 3.6rem",
  "@media only screen and (max-width: 750px)": {
    flexBasis: "74%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F2F2F2",
    height: "100%",
    borderRadius: "0.5rem",
    padding: "2.5rem 2.4rem 1.6rem 3.6rem",
  },
}));

export const CloseIconBoxWrapRight = styled(Box)(() => ({
  display: "flex",
  alignItems: "flex-start",
  height: "100%",
  cursor: "pointer",
  "@media only screen and (max-width: 750px)": {
    display: "none",
  },
}));

export const CloseIconBoxWrapLeft = styled(Box)(() => ({
  display: "flex",
  alignItems: "flex-start",
  height: "100%",
  cursor: "pointer",
  display: "none",
  "@media only screen and (max-width: 750px)": {
    display: "block",
    alignSelf: "flex-start",
  },
}));

export const ProfessionNameText = styled(Typography)(() => ({
  fontSize: "1.8rem",
  color: "#676767",
  maxWidth: "41rem",
  width: "100%",
  // textAlign: "left",
  cursor: "default",
  textWrap: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  textWrap: "wrap",
}));

export const AddressBox = styled(Box)(() => ({
  display: "flex",
  columnGap: "2rem",
  alignItems: "center",
}));

export const AddressText = styled(Typography)(() => ({
  fontSize: "1.4rem",
  color: "#676767",
  textAlign: "left",
  lineHeight: "1.67rem",
  cursor: "default",
  textWrap: "wrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  WebkitLineClamp: "2",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  "@media only screen and (max-width: 750px)": {
    padding: "1rem 0",
  },
}));

export const ButtonBoxWrap = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-start",
  columnGap: "1rem",
  flexDirection: "row",
  "@media only screen and (max-width: 750px)": {
    rowGap: "1rem",
    flexDirection: "column",
    padding: "1rem 0",
  },
}));

// Input Dialog Box

export const InputDialogBoxWrap = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "2.5rem",
  width: "75rem",
  overflow: "hidden",
  "@media only screen and (min-width: 600px) and (max-width: 750px)": {
    width: "55rem",
  },
  "@media only screen and (min-width: 450px) and (max-width: 599px)": {
    width: "45rem",
  },
  "@media only screen and (max-width: 450px)": {
    width: "33rem",
  },
}));

export const InputLabelBoxBig = styled(Box)(() => ({
  flex: "18%",
  overflow: "hidden",
  textAlign: "right",
  "@media only screen and (max-width: 750px)": {
    display: "none",
  },
}));

export const InputLabelBoxSmall = styled(Box)(() => ({
  flex: "18%",
  overflow: "hidden",
  textAlign: "left",
  display: "none",
  "@media only screen and (max-width: 749px)": {
    display: "block",
  },
}));

export const RequestDialogWrap = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "2.5rem",
  width: "69rem",
  overflow: "hidden",
  "@media only screen and (max-width: 750px)": {
    width: "auto",
    padding: "1rem",
  },
}));
